import { MapPinOff } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { backgroundGeolocation } from './native-bridge';

/**
 * Shown in place of the whole app when location is off on a company phone.
 *
 * The terms make location a condition of using the app; this is what that
 * looks like when it is not on. It offers the one action that fixes it —
 * opening the system settings for this app — and a way to re-check after,
 * though returning to the app re-checks on its own.
 */
export function LocationBlockedScreen({ onRecheck }: { onRecheck: () => void }) {
  const openSettings = () => {
    void backgroundGeolocation()?.openSettings();
  };

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-6 bg-background px-6 pb-[var(--inset-bottom)] pt-[var(--inset-top)] text-center">
      <span className="grid size-16 place-items-center rounded-full bg-destructive/10 text-destructive">
        <MapPinOff className="size-8" aria-hidden="true" />
      </span>
      <div className="max-w-sm space-y-2">
        <h1 className="text-xl font-semibold">Turn on location to continue</h1>
        <p className="text-sm text-muted-foreground">
          This app records where you are while you use it, and needs location switched on to
          open. Turn on location for KioBytes Telecom in your phone's settings, then come back.
        </p>
      </div>
      <div className="flex w-full max-w-xs flex-col gap-2">
        <Button onClick={openSettings}>Open location settings</Button>
        <Button variant="outline" onClick={onRecheck}>
          I have turned it on
        </Button>
      </div>
    </div>
  );
}
